<template>
  <div
    v-if="item.goods_type==1"
    class="item course-item"
    :key="item.id"
    @click="$router.push({name:'IntegralGoodsDetail',params:{id:item.id},query:{type:item.goods_type}})"
  >
    <div class="course-name">{{item.course_name}}</div>
    <div class="teacher-wrap">
      <div class="teacher" v-for="(tea,index) in item.teacher" :key="index" v-if="index<5">
        <img class="teacher-avatar" :src="tea.avatar" />
        <div class="teacher-name">{{tea.teacher_name}}</div>
      </div>
    </div>
    <div class="bottom">
      <span class="integral-wrap">
        <span class="integral">{{item.exchange_price}}</span>
        <span class="integral-label">{{point_name}}</span>
      </span>
      <router-link
        class="ink-detail"
        :to="{name:'IntegralGoodsDetail',params:{id:item.id},query:{type:item.goods_type}}"
      >去兑换</router-link>
    </div>
  </div>
  <div
    v-else
    class="item book-item"
    :key="item.id"
    @click="$router.push({name:'IntegralGoodsDetail',params:{id:item.id},query:{type:item.goods_type}})"
  >
    <img class="cover" :src="item.cover_img" />
    <div class="right">
      <div>
        <div class="book-name">{{item.book_name}}</div>
        <div class="book-author">{{item.author}}</div>
      </div>
      <div class="bottom">
        <span class="integral-wrap">
          <span class="integral">{{item.exchange_price}}</span>
          <span class="integral-label">{{point_name}}</span>
        </span>
        <router-link
          class="ink-detail"
          :to="{name:'IntegralGoodsDetail',params:{id:item.id},query:{type:item.goods_type}}"
        >去兑换</router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IntegralItem",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    point_name() {
      if(this.$store.state.config){
        return this.$store.state.config.point_info.point_name
      } else{
        return '';
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.item {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.07);
  border-radius: 20px;
  margin-bottom: 30px;
  padding: 20px 30px;

  .bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .integral-wrap {
    display: flex;
    align-items: center;
    height: 64px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(238, 31, 31, 1);
  }
  .integral {
    font-size: 32px;
    line-height: 64px;
  }
  .integral-label {
    font-size: 24px;
    line-height: 64px;
  }
  .ink-detail {
    display: inline-block;
    width: 104px;
    height: 42px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 22px;
    border: 1px solid rgba(183, 183, 183, 1);
    text-align: center;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
    line-height: 42px;
  }
}
.course-item {
  .course-name {
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 42px;
  }
  .teacher-wrap {
    display: flex;
    padding-top: 40px;
    padding-bottom: 30px;
    border-bottom: 1px solid #f5f5f5;
    margin-bottom: 10px;
    .point{
      display: flex;
      align-items: flex-end;
      color:rgba(0, 0, 0, 0.45);
    }
  }
  .teacher {
    text-align: center;
    margin-right: 40px;
    &:last-child {
      margin-right: 0;
    }
  }
  .teacher-avatar {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    margin-bottom: 6px;
  }
  .teacher-name {
    width: 80px;
    height: 32px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 32px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.book-item {
  padding: 30px 20px;
  display: flex;
  .cover {
    width: 172px;
    height: 242px;
    margin-right: 30px;
    border-radius: 15px;
  }
  .book-name {
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(32, 36, 42, 1);
    line-height: 42px;
    margin-bottom: 8px;
  }
  .book-author {
    height: 32px;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(140, 140, 140, 1);
    line-height: 34px;
  }
  .right {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
</style>
